module.exports = __webpack_public_path__ + "img/wallop.04aa39db.png";